import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Loremo",
  "description": "",
  "published": "2007-03-07T00:00:00.000Z",
  "redirect_from": ["/blog/loremo/swizec/270"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Veliko ljudi pravi, da je ta avto grd, cenen, premajhen in druge reci. Ampak osebno se mi zdi `}<a parentName="p" {...{
        "href": "http://loremo.com/"
      }}>{`Loremo`}</a>{` zelo zanimiv majhen avto. Seveda se mocno razlikuje od vsega cesar smo vajeni in je dalec od estetike sportnega avtomobila, ampak s tem ni nic narobe, ni bil misljen, da bi to bil, njegova ideja je biti futuristicno in ucinkovito malo vozilo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      